// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"3b132040","787":"f367b2eb"}[chunkId] + ".chunk.js";
};